import { Button } from "features/common/OSG";
import withReactRouterLink from "features/common/LinkHOC/LinkHOC";

export default withReactRouterLink(Button);
